import { render, staticRenderFns } from "./EndorsementContract.vue?vue&type=template&id=a860751c"
import script from "./EndorsementContract.vue?vue&type=script&lang=js"
export * from "./EndorsementContract.vue?vue&type=script&lang=js"
import style0 from "./EndorsementContract.vue?vue&type=style&index=0&id=a860751c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports